/*
This middleware is used to fetch all data required for the app to function when the user enters the app.
*/
import { useMasterDataStore } from "~/store/masterdata.store";
import { useBillingStore } from "~/store/billing.store";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const masterDataStore = useMasterDataStore();
  const billingStore = useBillingStore();

  // Only apply this middleware for routes under /app/*
  if (!to.path.startsWith("/app")) {
    return;
  }

  // Fetch app-wide data if entering the app for the first time or when accessing a page outside the app (initial load)
  if (!from.path.startsWith("/app") || from.name === undefined) {
    if (import.meta.client) {
      try {
        await Promise.all([
          masterDataStore.fetchMasterData(),
          billingStore.getCurrentBillingPeriod(),
          billingStore.getSubscriptionTypes(),
        ]);
      } catch (error) {
        console.log(
          "Not all data could be fetched - depending on the subscription type this may be intended",
          error
        );
      }
    }
  }

  // Set user's preferred language
  try {
    const { $i18n } = useNuxtApp();
    const preferredLanguage = localStorage.getItem("preferredLanguage") || "en";
    $i18n.setLocale(preferredLanguage);
    localStorage.setItem("preferredLanguage", preferredLanguage);
  } catch (error) {
    console.error("Failed to set preferred language:", error);
  }
});
